const aeJSON = {
  "Tokyo": "Muraqabah Pilgrimage portal",
  "Accent Sidebar": "لهجة الشريط الجانبي",
  "Tokyo White React Typescript Admin Dashboard": "Muraqabah Pilgrimage portal",
  "Tokyo React Typescript Admin Dashboard": "Muraqabah Pilgrimage portal",
  "Tokyo Black React Typescript Admin Dashboard": "Muraqabah Pilgrimage portal",
  "&copy; 2026 - Muraqabah Pilgrimage portal": "&copy; 2026 - Muraqabah Pilgrimage portal",
  "Muraqabah Pilgrimage portal": "Muraqabah Pilgrimage portal",
  "Dashboards": "لوحات المعلومات",
  "Dashboard": "لوحة القيادة",
  "General": "عام",
  "Roles": "الأدوار",
  "Vendor Management": "إدارة البائعين",
  "Vendors": "الباعة",
  "Package": "طَرد",
  "Packages": "الحزم",
  "Master": "يتقن",
  "Master Data": "البيانات الرئيسية",
  "Master_Data_type": "نوع البيانات الرئيسية مطلوب",
  "Inquiry": "سؤال",
  "Inquiry Management": "إدارة الاستفسار",
  "Inquiries": "الاستفسارات",
  "Service Management": "إدارة الخدمة",
  "Business Profile": "الملف التجاري",
  "your_analytics": "هذه هي احصائيات التحليلات الخاصة بك لهذا اليوم",
  "Search_by_name": "البحث حسب الاسم أو الرمز القصير أو الوصف...",
  "Welcome": "مرحباً",
  "Active Referrals": "الإحالات النشطة",
  "See referring domains": "انظر المجالات المرجعية",
  "which sent most traffic": "التي أرسلت معظم حركة المرور",
  "Pending Invitations": "الدعوات المعلقة",
  "Not opened yet": "لم يفتح بعد",
  "See all invitations": "شاهد جميع الدعوات",
  "Sessions by Country": "الجلسات حسب البلد",
  "Bounce Rate": "معدل الارتداد",
  "See all links": "انظر جميع الروابط",
  "with high bounce rate.": "مع ارتفاع معدل الارتداد.",
  "Conversion": "تحويل",
  "with the best conversion rates.": "مع أفضل معدلات التحويل.",
  "See products": "انظر المنتجات",
  "Audience Overview": "نظرة عامة على الجمهور",
  "Today": "اليوم",
  "Yesterday": "أمس",
  "Last month": "الشهر الماضي",
  "Last year": "العام الماضي",
  "Users": "المستخدمين",
  "New users": "مستخدمين جدد",
  "Page views": "مشاهدات الصفحة",
  "Avg. session duration": "متوسط مدة الجلسة",
  "Sessions": "الجلسات",
  "Conversions": "التحويلات",
  "Sales Today": "المبيعات اليوم",
  "Customers per month": "العملاء شهريا",
  "Earnings Report": "تقرير الأرباح",
  "Top Landing Pages": "أعلى الصفحات المقصودة",
  "Impressions": "انطباعات",
  "Clicks": "النقرات",
  "Visit URL": "زيارة URL",
  "Traffic Sources": "مصادر المرور",
  "Generate Chart": "إنشاء مخطط",
  "pages/session": "الصفحات/الجلسة",
  "New Sessions": "جلسات جديدة",
  "User & Role Management": "إدارة المستخدم والأدوار",
  "Management": "إدارة",
  "user_can_be_managed": "يمكن إدارة جميع الجوانب المتعلقة بالمستخدم من هذه الصفحة",
  "Add": "يضيف",
  "role_can_be_managed": "يمكن إدارة جميع الجوانب المتعلقة بالدور من هذه الصفحة",
  "Role_required": "اسم الدور مطلوب",
  "Add new role": "إضافة دور جديد",
  "Edit role details": "تحرير تفاصيل الدور",
  "fields_new_role": "املأ الحقول أدناه لإضافة دور جديد.",
  "Role Name": "اسم الدور",
  "Short Code": "الرمز القصير",
  "Description": "وصف",
  "Cancel": "يلغي",
  "Save": "يحفظ",
  "Edit": "يحرر",
  "Url": "عنوان URL",
  "Delete": "يمسح",
  "Tour Itinerary": "خط سير الرحلة",
  "below_to_edit": "املأ الحقول أدناه لتعديل تفاصيل الدور.",
  "Description_required": "الوصف مطلوب",
  "Short_Code_required": "مطلوب رمز قصير",
  "Special_Chars_not_allowed": "الأحرف والأرقام الخاصة غير مسموح بها.",
  "Search by name, shortcode or description...": "البحث حسب الاسم أو الرمز القصير أو الوصف...",
  "Sr. No.": "السيد رقم",
  "Name": "اسم",
  "Shortcode": "الرمز القصير",
  "Created By": "تم الإنشاء بواسطة",
  "Modified By": "تم التعديل بواسطة",
  "Actions": "الإجراءات",
  "Loading...": "تحميل...",
  "No results found": "لم يتم العثور على نتائج",
  "Advanced View": "عرض متقدم",
  "Assigned Roles": "الأدوار المخصصة",
  "Password": "كلمة المرور",
  "Email": "بريد إلكتروني",
  "Last name": "اسم العائلة",
  "First name": "الاسم الأول",
  "Airlines": "الخطوط الجوية",
  "Select room sharing": "اختر مشاركة الغرفة",
  "Room Sharing": "مشاركة الغرفة",
  "Package Type": "نوع الحزمة",
  "Select package type": "حدد نوع الحزمة",
  "Package Details": "تفاصيل الحزمة",
  "Package Name": "اسم الحزمة",
  "Departure": "رحيل",
  "Package Room Sharing": "مشاركة غرفة الحزمة",
  "Package Airline": "حزمة طيران",
  "Package Amount": "مبلغ الحزمة",
  "Package Inquiry Date": "تاريخ الاستفسار عن الحزمة",
  "Inquiry Date": "تاريخ الاستفسار",
  "Vendor Name": "اسم البائع",
  "Phone Number": "رقم التليفون",
  "Customer Email": "البريد الإلكتروني للعميل",
  "Customer Name": "اسم العميل",
  "Status": "حالة",
  "Customer Phone No.": "رقم هاتف العميل",
  "Customer Phone Number": "رقم هاتف العميل",
  "Search_by_customer_name": "البحث حسب اسم العميل، البريد الإلكتروني، رقم الهاتف، نوع الحزمة، الاسم، مشاركة الغرفة...",
  "Status Type": "نوع الحالة",
  "Select status type": "اختر نوع الحالة",
  "NEW LEAD": "قيادة جديدة",
  "FOLLOW UP": "متابعة",
  "CLOSED": "مغلق",
  "NOT INTERESTED": "غير مهتم",
  "NOT CONTACTED": "لم يتم الاتصال",
  "Room Sharing is required": "مطلوب مشاركة الغرفة",
  "PACKAGE_TYPE": "PACKAGE_TYPE",
  "AIRLINES_TYPE": "AIRLINES_TYPE",
  "ROOM_SHARING": "مشاركة الغرفة",
  "INCLUSION_TYPE": "INCLUSION_TYPE",
  "EXCLUSION_TYPE": "EXCLUSION_TYPE",
  "An_error_occurred": "حدث خطأ أثناء إنشاء البيانات الرئيسية",
  "Master_Type": "نوع البيانات الرئيسية",
  "Select master data type": "حدد نوع البيانات الرئيسية",
  "Update": "تحديث",
  "End Date": "تاريخ الانتهاء",
  "Search_by_master_data": "البحث بالاسم...",
  "Inclusions_and_Package": "الادراج ويسلط الضوء على الحزمة",
  "Exclusions": "الاستثناءات",
  "Upload Images": "تحميل الصور",
  "Days": "أيام",
  "Search by customer name, email,phone no,package name,vendor name...": "البحث حسب اسم العميل والبريد الإلكتروني ورقم الهاتف واسم الحزمة واسم البائع ...",
  "Search by customer name, email,phone no,package name": "البحث حسب اسم العميل والبريد الإلكتروني ورقم الهاتف واسم الحزمة",
  "From Date": "من التاريخ",
  "To Date": "حتى الآن",
  "ID": "بطاقة تعريف",
  "Search": "يبحث",
  "Customer Lead": "قائد العميل",
  "Vendor Lead": "الرصاص البائع",
  "Search by vendor name": "البحث حسب اسم البائع...",
  "Customer Lead Details": "تفاصيل العميل المتوقع",
  "Vendor Lead Details": "تفاصيل الرصاص البائع",
  "Vendor List": "قائمة البائعين",
  "Lead Count": "عدد الرصاص",
  "Package Lead Count": "عدد عملاء الحزمة",
  "Search by name or email...": "البحث بالاسم أو البريد الإلكتروني...",
  "Search by business name, mobile number, email or registered at...": "ابحث حسب اسم العمل أو رقم الهاتف المحمول أو البريد الإلكتروني أو المسجل في...",
  "Search by description": "البحث حسب الوصف",
  "In-Active": "غير نشط",
  "The url field is required": "حقل عنوان URL مطلوب",
  "The description field is required": "حقل الوصف مطلوب",
  "The position field is required": "حقل الموقف مطلوب",
  "Business Information": "معلومات الأعمال",
  "Mobile Number": "رقم الهاتف المحمول",
  "Email ID": "معرف البريد الإلكتروني",
  "Complete Your Profile": "أكمل ملفك الشخصي",
  "Back": "خلف",
  "Complete Now": "أكمل الآن",
  "Complete Your Profile in Just a Few Easy Steps!": "أكمل ملفك الشخصي في بضع خطوات سهلة فقط!",
  "Search by customer name or email...": "البحث حسب اسم العميل أو البريد الإلكتروني...",
  "Search by package name...": "البحث حسب اسم الحزمة...",
  "Search by package name, package type or room sharing...": "ابحث حسب اسم الحزمة أو نوع الحزمة أو مشاركة الغرفة...",
  "Hajj/Umrah Package": "باقة الحج/العمرة",
  "Customer Details": "تفاصيل العميل",
  "Package Lead": "الرصاص الحزمة",
  "The Mobile No field is required": "حقل رقم الجوال مطلوب",
  "The username field is required": "حقل اسم المستخدم مطلوب",
  "The email provided should be a valid email address": "يجب أن يكون البريد الإلكتروني المقدم عنوان بريد إلكتروني صالحًا",
  "The email field is required": "حقل البريد الإلكتروني مطلوب",
  "The role field is required": "حقل الدور مطلوب",
  "User Name": "اسم المستخدم",
  "Email address": "عنوان البريد الإلكتروني",
  "Edit Bottom  Banner": "تحرير الشعار السفلي",
  "Upload image": "تحميل الصورة",
  "Bottom Banner Position": "موضع الشعار السفلي",
  "The top banner created successfully": "تم إنشاء الشعار العلوي بنجاح",
  "The banner has been updated": "تم تحديث اللافتة",
  "Please upload an image": "يرجى تحميل صورة",
  "Top Banner Position": "موضع الشعار العلوي",
  "Couldn't update Position": "تعذر تحديث المنصب",
  "Position has been updated": "تم تحديث الموقف",
  "Bottom Banner": "لافتة سفلية",
  "Position": "موضع",
  "The bottom banner status has been updated": "تم تحديث حالة البانر السفلي",
  "Couldn't update bottom banner status": "تعذر تحديث حالة البانر السفلي",
  "The role account created successfully": "تم إنشاء حساب الدور بنجاح",
  "Package Detail has been updated": "تم تحديث تفاصيل الحزمة",
  "Error while saving package detail": "حدث خطأ أثناء حفظ تفاصيل الحزمة",
  "Package detail saved successfully": "تم حفظ تفاصيل الحزمة بنجاح",
  "Package Details approved successfully": "تمت الموافقة على تفاصيل الحزمة بنجاح",
  "Error while approving Package Details": "حدث خطأ أثناء الموافقة على تفاصيل الحزمة",
  "Hotel Details approved successfully": "تمت الموافقة على تفاصيل الفندق بنجاح",
  "Error while approving Hotel Details": "حدث خطأ أثناء الموافقة على تفاصيل الفندق",
  "Tour Itinerary approved successfully": "تمت الموافقة على خط سير الرحلة بنجاح",
  "Error while approving Tour Itinerary": "حدث خطأ أثناء الموافقة على خط سير الرحلة",
  "Error while approving Inclusions": "حدث خطأ أثناء الموافقة على التضمينات",
  "Inclusions approved successfully": "تمت الموافقة على الادراج بنجاح",
  "Exclusions approved successfully": "تمت الموافقة على الاستثناءات بنجاح",
  "Error while approving Exclusions": "حدث خطأ أثناء الموافقة على الاستثناءات",
  "Comment Added Successfully": "تمت إضافة التعليق بنجاح",
  "The days are not specific to the provider dates": "الأيام ليست محددة لتواريخ المزود",
  "Row saved successfully": "تم حفظ الصف بنجاح",
  "Row updated successfully": "تم تحديث الصف بنجاح",
  "Row deleted successfully": "تم حذف الصف بنجاح",
  "Row Saved Successfully": "تم حفظ الصف بنجاح",
  "Row has been updated": "تم تحديث الصف",
  "Row Deleted Successfully": "تم حذف الصف بنجاح",
  "An error occurred while creating the role": "حدث خطأ أثناء إنشاء الدور",
  "Record has been updated": "تم تحديث السجل",
  "Error while updating record": "حدث خطأ أثناء تحديث السجل",
  "Remark has been saved successfully": "تم حفظ الملاحظة بنجاح",
  "Error while saving remark": "حدث خطأ أثناء حفظ الملاحظة",
  "Permissions has been updated": "تم تحديث الأذونات",
  "Package status has been updated": "تم تحديث حالة الحزمة",
  "Couldn't update package status": "لا يمكن تحديث حالة الحزمة",
  "Password successfully changed": "تم تغيير كلمة المرور بنجاح",
  "Image size is too large": "حجم الصورة كبير جدًا",
  "The bottom banner created successfully": "تم إنشاء الشعار السفلي بنجاح",
  "The banner was updated successfully": "تم تحديث البانر بنجاح",
  "Role status has been updated": "تم تحديث حالة الدور",
  "Couldn't update role status": "تعذر تحديث حالة الدور",
  "The user account created successfully": "تم إنشاء حساب المستخدم بنجاح",
  "User status has been updated": "تم تحديث حالة المستخدم",
  "Couldn't update user status": "تعذر تحديث حالة المستخدم",
  "The card has been removed successfully": "تمت إزالة البطاقة بنجاح",
  "The master data added successfully": "تمت إضافة البيانات الرئيسية بنجاح",
  "The master data has been updated": "تم تحديث البيانات الرئيسية",
  "Master data status has been updated": "تم تحديث حالة البيانات الرئيسية",
  "Couldn't update master data status": "تعذر تحديث حالة البيانات الرئيسية",
  "Vendor details approved successfully": "تمت الموافقة على تفاصيل البائع بنجاح",
  "Error while approving vendor details": "حدث خطأ أثناء الموافقة على تفاصيل البائع",
  "Comment added successfully": "تمت إضافة التعليق بنجاح",
  "Business Information updated successfully": "تم تحديث معلومات العمل بنجاح",
  "Error while updating Business Information": "حدث خطأ أثناء تحديث معلومات العمل",
  "Documents updated successfully": "تم تحديث المستندات بنجاح",
  "Error while updating Documents": "حدث خطأ أثناء تحديث المستندات",
  "Types of Tour updated successfully": "تم تحديث أنواع الجولات بنجاح",
  "Error while updating Types of Tour": "حدث خطأ أثناء تحديث أنواع الرحلات",
  "Payment Mode updated successfully": "تم تحديث وضع الدفع بنجاح",
  "Error while updating Payment Mode": "حدث خطأ أثناء تحديث وضع الدفع",
  "File uploaded successfully": "تم تحميل الملف بنجاح",
  "Error while uploading file": "حدث خطأ أثناء تحميل الملف",
  "File deleted successfully": "تم حذف الملف بنجاح",
  "Error while deleting file": "حدث خطأ أثناء حذف الملف",
  "Package rejected successfully": "تم رفض الحزمة بنجاح",
  "An error occurred while rejecting package": "حدث خطأ أثناء رفض الحزمة",
  "Add Reason for Rejection": "أضف سبب الرفض",
  "The Vendor account created successfully": "تم إنشاء حساب البائع بنجاح",
  "The user account has been updated": "تم تحديث حساب المستخدم",
  "Vendor status has been updated": "تم تحديث حالة البائع",
  "Could not update vendor status": "لا يمكن تحديث حالة البائع",
  "Password has been successfully sent to you email": "لقد تم إرسال كلمة المرور بنجاح إلى البريد الإلكتروني الخاص بك",
  "Total Package Count": "إجمالي عدد الطرود",
  "Total Lead Count": "إجمالي عدد الرصاص",
  "Active": "نشيط",
  "Inactive": "غير نشط",
  "Lead Management": "إدارة الرصاص",
  "Lead": "يقود",
  "Are you sure you want to Activate this package?": "هل أنت متأكد أنك تريد تفعيل هذه الحزمة",
  "Are you sure you want to In-Activate this package": "هل أنت متأكد أنك تريد تفعيل هذه الحزمة",
  "Activate": "فعل",
  "In-Activate": "في التنشيط",
  "Are you sure you want to Activate this banner?": "هل أنت متأكد أنك تريد تفعيل هذا الشعار؟",
  "Are you sure you want to In-Activate this banner?": "هل أنت متأكد أنك تريد تفعيل هذا الشعار؟",
  "Are you sure you want to In-Activate this role?": "هل أنت متأكد أنك تريد إلغاء تنشيط هذا الدور؟",
  "Are you sure you want to Activate this role?": "هل أنت متأكد أنك تريد تفعيل هذا الدور؟",
  "Are you sure you want to In-Activate this user": "هل أنت متأكد أنك تريد تفعيل هذا المستخدم؟",
  "Are you sure you want to In-Activate this user?": "هل أنت متأكد أنك تريد تفعيل هذا المستخدم؟",
  "Are you sure you want to Activate this user?": "هل أنت متأكد أنك تريد تفعيل هذا المستخدم؟",
  "Are you sure you want to In-Activate this master data?": "هل أنت متأكد من رغبتك في تنشيط هذه البيانات الرئيسية؟",
  "Are you sure you want to Activate this master data?": "هل أنت متأكد أنك تريد تنشيط هذه البيانات الرئيسية؟",
  "Are you sure you want to In-Activate this vendor?": "هل أنت متأكد أنك تريد تفعيل هذا البائع؟",
  "Are you sure you want to Activate this vendor?": "هل أنت متأكد أنك تريد تنشيط هذا البائع؟",
  "Banner Management": "إدارة البانر",
  "Banner": "راية",
  "Banner Top": "راية أعلى",
  "Banner Bottom": "راية أسفل",
  "Type of Tours Provided": "نوع الجولات المقدمة",
  "Haj": "الحاج",
  "Umrah": "العمرة",
  "Ziyarat": "زيارات",
  "Pincode": "الرمز السري",
  "Country": "دولة",
  "State": "ولاية",
  "Select City": "اختر المدينة",
  "Landmark": "معلم",
  "Area": "منطقة",
  "Unit, Block, Wing, Building Name": "الوحدة، الكتلة، الجناح، اسم المبنى",
  "Street Name": "اسم الشارع",
  "Address": "عنوان",
  "Business Description": "وصف الأعمال",
  "Uploading...": "جارٍ التحميل...",
  "Upload Company Logo": "تحميل شعار الشركة",
  "Company Logo": "شعار الشركة",
  "Email Address": "عنوان البريد الإلكتروني",
  "Year of Establishment": "سنة التأسيس",
  "Business Name": "اسم العمل",
  "Account & Business Information": "معلومات الحساب والأعمال",
  "Cheque": "يفحص",
  "Credit Card": "بطاقة إئتمان",
  "Debit Card": "بطاقة الخصم",
  "Cash": "نقدي",
  "UPI": "واجهة الدفع الموحدة (UPI).",
  "Online Booking": "الحجز عبر الإنترنت",
  "Demand Draft": "مسودة الطلب",
  "Payment Mode": "وضع الدفع",
  "Member/Accredited/Authorised": "عضو/معتمد/مفوض",
  "IATA License": "رخصة اتحاد النقل الجوي الدولي",
  "Upload IATA License": "تحميل رخصة اتحاد النقل الجوي الدولي",
  "Ministry of Tourism (GOI)": "وزارة السياحة (GOI)",
  "Allowed *.jpeg, *.jpg, *.png, *.pdf": "مسموح به *.jpeg، *.jpg، *.png، *.pdf",
  "Upload Ministry of Tourism (GOI)": "تحميل وزارة السياحة (GOI)",
  "HGO": "HGO",
  "Upload HGO": "تحميل HGO",
  "PAN": "مِقلاة",
  "Upload PAN": "تحميل عموم",
  "Business PAN": "عموم الأعمال",
  "Upload Business PAN": "تحميل PAN للأعمال",
  "GST Number": "رقم ضريبة السلع والخدمات",
  "Upload GST Certificate": "تحميل شهادة ضريبة السلع والخدمات",
  "GST Certificate": "شهادة ضريبة السلع والخدمات",
  "Package Name is required": "اسم الحزمة مطلوب",
  "Package Type is required": "نوع الحزمة مطلوب",
  "Number of days is required": "عدد الأيام مطلوب",
  "Number of days must be a positive number": "يجب أن يكون عدد الأيام رقمًا موجبًا",
  "Number of days must be an integer": "يجب أن يكون عدد الأيام عددًا صحيحًا",
  "Room sharing is required": "مشاركة الغرفة مطلوبة",
  "Room sharing must be at least 1 characters": "يجب أن تكون مشاركة الغرفة حرفًا واحدًا على الأقل",
  "Room sharing must be at most 255 characters": "يجب أن تكون مشاركة الغرفة 255 حرفًا على الأكثر",
  "Airline is required": "مطلوب شركة طيران",
  "Departure date is required": "تاريخ المغادرة مطلوب",
  "Return Date is required": "تاريخ العودة مطلوب",
  "City is required": "المدينة مطلوبة",
  "Package Amount is required": "مبلغ الحزمة مطلوب",
  "Package Amount must be a positive number": "يجب أن يكون مبلغ الحزمة رقمًا موجبًا",
  "Business name is required": "الاسم التجاري مطلوب",
  "The password field is required": "حقل كلمة المرور مطلوب",
  "IATA License is required": "مطلوب رخصة اتحاد النقل الجوي الدولي",
  "File Size is too large": "حجم الملف كبير جدًا",
  "Ministry of Tourism is required": "مطلوب وزارة السياحة",
  "HGO is required": "مطلوب HGO",
  "PAN is required": "مطلوب PAN",
  "Pan Card number is not valid": "رقم بطاقة Pan غير صالح",
  "Business PAN is required": "مطلوب PAN الأعمال",
  "Business Pan Card number is not valid": "رقم بطاقة Pan Business غير صالح",
  "GST number is not valid": "رقم ضريبة السلع والخدمات غير صالح",
  "Pan Document is required": "مطلوب وثيقة عموم",
  "Business Pan Document is required": "وثيقة الأعمال مطلوبة",
  "GST Certificate Document is required": "وثيقة شهادة ضريبة السلع والخدمات مطلوبة",
  "Unsupported Format": "تنسيق غير مدعوم",
  "Select city": "اختر المدينة",
  "Return": "يعود",
  "Hotel Details": "تفاصيل الفندق",
  "Distance": "مسافة",
  "Location": "موقع",
  "Inclusions and Package Highlights": "الادراج ويسلط الضوء على الحزمة",
  "Registered At": "مسجل في",
  "ALL": "الجميع",
  "PENDING": "قيد الانتظار",
  "INPROCESS": "معالجة",
  "COMPLETED": "مكتمل",
  "REJECTED": "مرفوض",
  "The mobile no. must be at most 10 digits": "رقم الجوال. يجب أن يكون 10 أرقام على الأكثر",
  "The mobile no. must be at least 10 digits": "رقم الجوال. يجب أن يكون 10 أرقام على الأقل",
  "The business name must be at most 50 characters": "يجب أن يكون اسم النشاط التجاري 50 حرفًا على الأكثر",
  "The business name must be at least 1 character": "يجب أن يتكون اسم النشاط التجاري من حرف واحد على الأقل",
  "The username must be at most 20 characters": "يجب أن يكون اسم المستخدم 20 حرفًا على الأكثر",
  "The email field must be at least 3 characters": "يجب أن يتكون حقل البريد الإلكتروني من 3 أحرف على الأقل",
  "The email must be at most 320 characters": "يجب أن يكون البريد الإلكتروني 320 حرفًا على الأكثر",
  "The password must be at most 8 characters": "يجب أن تكون كلمة المرور مكونة من 8 أحرف على الأكثر",
  "The password field must be at least 8 characters": "يجب أن يتكون حقل كلمة المرور من 8 أحرف على الأقل",
  "Package Name must be at least 4 characters": "يجب أن يتكون اسم الحزمة من 4 أحرف على الأقل",
  "Package Name must be at most 255 characters": "يجب أن يكون اسم الحزمة 255 حرفًا على الأكثر",
  "Role name must be at least 1 character": "يجب أن يتكون اسم الدور من حرف واحد على الأقل",
  "Shortcode must be at most 5 characters": "يجب أن يتكون الرمز القصير من 5 أحرف على الأكثر",
  "Shortcode must be at least 1 character": "يجب أن يتكون الرمز القصير من حرف واحد على الأقل",
  "Description must be at least 1 character": "يجب أن يتكون الوصف من حرف واحد على الأقل",
  "Description must be at most 255 characters": "يجب أن يكون الوصف 255 حرفًا على الأكثر",
  "Remark is required": "الملاحظة مطلوبة",
  "Remark must be at least 4 characters": "يجب أن تكون الملاحظة 4 أحرف على الأقل",
  "Remark must be at most 255 characters": "يجب أن تكون الملاحظة 255 حرفًا على الأكثر",
  "The name field must be at least 3 characters": "يجب أن يتكون حقل الاسم من 3 أحرف على الأقل",
  "The name field must be at most 50 characters": "يجب أن يكون حقل الاسم 50 حرفًا على الأكثر",
  "The role field must be at least 1 characters": "يجب أن يتكون حقل الدور من حرف واحد على الأقل",
  "Password must be 8 characters long": "يجب أن تتكون كلمة المرور من 8 أحرف",
  "Password requires a number": "كلمة المرور تتطلب رقما",
  "Password requires a lowercase letter": "تتطلب كلمة المرور حرفًا صغيرًا",
  "Password requires an uppercase letter": "تتطلب كلمة المرور حرفًا كبيرًا",
  "Password requires a symbol": "كلمة المرور تتطلب رمزا",
  "The username field must be at least 3 characters": "يجب أن يتكون حقل اسم المستخدم من 3 أحرف على الأقل",
  "The username field must be at most 20 characters": "يجب أن يتكون حقل اسم المستخدم من 20 حرفًا على الأكثر",
  "The first name field must be at least 3 characters": "يجب أن يتكون حقل الاسم الأول من 3 أحرف على الأقل",
  "The first name field must be at most 25 characters": "يجب أن يتكون حقل الاسم الأول من 25 حرفًا على الأكثر",
  "The first name field is required": "حقل الاسم الأول مطلوب",
  "The last name field must be at least 3 characters": "يجب أن يتكون حقل الاسم الأخير من 3 أحرف على الأقل",
  "The last name field must be at most 25 characters": "يجب أن يحتوي حقل الاسم الأخير على 25 حرفًا على الأكثر",
  "The last name field is required": "حقل الاسم الأخير مطلوب",
  "Pincode must be an integer": "يجب أن يكون الرمز السري عددًا صحيحًا",
  "Pincode must be a positive number": "يجب أن يكون الرقم السري رقمًا موجبًا",
  "Pincode is required": "مطلوب الرمز السري",
  "Pincode must be a number": "يجب أن يكون الرمز السري رقمًا",
  "Country is required": "البلد مطلوب",
  "State is required": "الدولة مطلوبة",
  "Landmark is required": "المعالم مطلوبة",
  "Area is required": "المنطقة مطلوبة",
  "Address is required": "العنوان مطلوب",
  "Street Name is required": "اسم الشارع مطلوب",
  "Year of Establishment is required": "سنة التأسيس مطلوبة",
  "Comment is required": "التعليق مطلوب",
  "Comment must be at least 1 character": "يجب أن يتكون التعليق من حرف واحد على الأقل",
  "Comment must be at most 255 characters": "يجب أن يكون التعليق 255 حرفًا على الأكثر",
  "You must agree to our terms and conditions": "يجب عليك الموافقة على الشروط والأحكام الخاصة بنا",
  "Inactive Top Banners": "أعلى اللافتات غير النشطة",
  "Inactive Bottom Banners": "اللافتات السفلية غير النشطة",
  "Mobile Image": "صورة الجوال",
  "Desktop Image": "صورة سطح المكتب",
  "Banner Created Date": "تاريخ إنشاء الشعار",
  "Banner Updated Date": "تاريخ تحديث البانر",
  "Maximum number of active banners exeeded": "تم تنفيذ الحد الأقصى لعدد اللافتات النشطة",
  "Image dimension should be greater than 1000 X 1900 px": "يجب أن يكون أبعاد الصورة أكبر من 1000 × 1900 بكسل",
  "Image dimension should be greater than 380 X 499 px": "يجب أن يكون أبعاد الصورة أكبر من 380 × 499 بكسل",
  "Search by url...": "البحث عن طريق عنوان URL...",
  "Change Your Password": "تغيير كلمة المرور الخاصة بك",
  "Enter your new password": "أدخل كلمة المرور الجديدة",
  "Notifications": "إشعارات",
  "Reset Password": "إعادة تعيين كلمة المرور",
  "Profile": "حساب تعريفي",
  "Sign Out": "تسجيل الخروج",
  "Profile Under Review": "الملف الشخصي قيد المراجعة",
  "Review And Rating": "المراجعة والتقييم",
  "Review And Rating Management": "إدارة المراجعة والتقييم",
  "Search by customer name,email,package name,vendor name...": "البحث حسب اسم العميل والبريد الإلكتروني واسم الحزمة واسم البائع ...",
  "Content": "محتوى",
  "Content Management": "إدارة المحتوى",
  "Preview": "معاينة",
  "Upload": "رفع",
  "Title": "عنوان",
  "Top Banner Clicks Detail": "تفاصيل نقرات الجزء العلوي من الشعار",
  "Bottom Banner Clicks Detail": "تفاصيل النقرات على الشعار السفلي",
  "Inactive Top Banner Clicks Detail": "تفاصيل النقرات غير النشطة على الشعار العلوي",
  "Inactive Bottom Banner Clicks Detail": "تفاصيل النقرات على الشعار السفلي غير النشط",
  "Clicks Detail": "تفاصيل النقرات",
  "Are you sure you want to Activate this content?": "هل أنت متأكد أنك تريد تفعيل هذا المحتوى؟",
  "Are you sure you want to In-Activate this content?": "هل أنت متأكد أنك تريد تفعيل هذا المحتوى؟",
  "Enter title": "أدخل العنوان",
  "Please enter content title": "الرجاء إدخال عنوان المحتوى",
  "Please enter description": "الرجاء إدخال الوصف",
  "FOOD RATING": "تقييم الغذاء",
  "HOTEL RATING": "تصنيف الفندق",
  "JIYARAT RATING": "تصنيف جيارات",
  "COMMENTS": "تعليقات",
  "Search by title,subtitle and description...": "البحث حسب العنوان والعنوان الفرعي والوصف...",
  "Sub Title": "العنوان الفرعي",
  "How to choose your tour packages?": "كيف تختار برامجك السياحية؟",
  "How to apply for Haj?": "كيفية التقديم للحج؟",
  "Type of Hajj": "نوع الحج",
  "Highest standards of professionalism, integrity, and personal service": "أعلى معايير الاحتراف والنزاهة والخدمة الشخصية",
  "Full co-ordination during your stay": "التنسيق الكامل أثناء إقامتك",
  "Exclusive deals with leading Umrah service providers in Saudi Arabia": "عروض حصرية مع كبار مقدمي خدمات العمرة في المملكة العربية السعودية",
  "Question": "سؤال",
  "Answer": "إجابة",
  "Keyword": "الكلمة الرئيسية",
  "Apply for Haj": "التقدم بطلب الحج",
  "Type of Haj": "نوع الحج",
  "Choose tour packages": "اختر البرامج السياحية",
  "Standards": "المعايير",
  "Stay": "يقضي",
  "Exclusive deals": "عروض حصرية",
  "The content has been updated": "تم تحديث المحتوى",
  "Record status has been updated": "تم تحديث حالة السجل",
  "Couldn't update content status": "تعذر تحديث حالة المحتوى",
  "The content saved successfully": "تم حفظ المحتوى بنجاح",
  "The content updated successfully": "تم تحديث المحتوى بنجاح",
  "FAQ record deleted successfully": "تم حذف سجل الأسئلة الشائعة بنجاح",
  "An error occured while updating FAQ": "حدث خطأ أثناء تحديث الأسئلة الشائعة",
  "An error occured while saving FAQ": "حدث خطأ أثناء حفظ الأسئلة الشائعة",
  "FAQ updated successfully": "تم تحديث الأسئلة الشائعة بنجاح",
  "FAQ saved successfully": "تم حفظ الأسئلة الشائعة بنجاح",
  "Spaces are not allowed": "لا يسمح بالمسافات",
  "Record deleted successfully": "تم حذف السجل بنجاح",
  "Content Pages": "صفحات المحتوى",
  "Content Sections": "أقسام المحتوى",
  "Tree View": "عرض الشجرة",
  "Search by page name or menu name...": "البحث حسب اسم الصفحة أو اسم القائمة...",
  "Section name": "اسم القسم",
  "Page name": "اسم الصفحة",
  "Menu Name": "اسم القائمة",
  "View & Edit": "عرض وتحرير",
  "Enter section name": "أدخل اسم القسم",
  "Enter page name": "أدخل اسم الصفحة",
  "Enter menu name": "أدخل اسم القائمة",
  "Enter keyword": "أدخل الكلمة الرئيسية",
  "Add FAQ": "أضف الأسئلة الشائعة",
  "Update & Publish": "تحديث ونشر",
  "Save & Publish": "حفظ ونشر",
  "The content field is required": "حقل المحتوى مطلوب",
  "Icon dimension is not correct": "أبعاد الرمز غير صحيحة",
  "Please select a PNG image": "الرجاء اختيار صورة PNG",
  "Update Section Details": "تحديث تفاصيل القسم",
  "Add Section Details": "إضافة تفاصيل القسم",
  "Icon": "رمز",
  "No file is selected": "لم يتم تحديد أي ملف",
  "Upload Icon": "أيقونة التحميل",
  "Minimum height and width should be 600 X 1000 pixel": "يجب أن يكون الحد الأدنى للارتفاع والعرض 600 × 1000 بكسل",
  "Minimum height and width should be 800 X 1200 pixel": "يجب أن يكون الحد الأدنى للارتفاع والعرض 800 × 1200 بكسل",
  "Upload image for Mobile": "تحميل الصورة للجوال",
  "Upload image for Desktop": "تحميل الصورة لسطح المكتب",
  "Add Banner Details": "أضف تفاصيل الشعار",
  "Allowed *.jpeg, *.jpg, *.png, *.gif": "مسموح به *.jpeg، *.jpg، *.png، *.gif",
  "Allowed *.png": "مسموح *.png",
  "Minimum height and width should be 32 X 32 pixel": "يجب أن يكون الحد الأدنى للارتفاع والعرض 32 × 32 بكسل",
  "Mobile Image uploaded successfully": "تم تحميل صورة الجوال بنجاح",
  "Error while uploading an image": "حدث خطأ أثناء تحميل الصورة",
  "Desktop Image uploaded successfully": "تم تحميل صورة سطح المكتب بنجاح",
  "Icon uploaded successfully": "تم تحميل الأيقونة بنجاح",
  "Error while uploading an icon": "حدث خطأ أثناء تحميل أيقونة",
  "Currency status has been updated": "تم تحديث حالة العملة",
  "Could not update Currency status": "تعذر تحديث حالة العملة",
  "The currency field must be at least 1 characters": "يجب أن يتكون حقل العملة من حرف واحد على الأقل",
  "The currency field is required": "حقل العملة مطلوب",
  "The currency has been added sucessfuly": "تمت إضافة العملة بنجاح",
  "Currency Name": "اسم العملة",
  "Available Currencies": "العملات المتاحة",
  "Are you sure you want to logout?": "هل أنت متأكد أنك تريد تسجيل الخروج؟",
  "Yes": "نعم",
  "The admin will review your profile, and approval will be granted once the review process is complete.": "سيقوم المشرف بمراجعة ملفك الشخصي، وسيتم منح الموافقة بمجرد اكتمال عملية المراجعة.",
  "Your Profile Is Not Approved Yet": "لم تتم الموافقة على ملفك الشخصي بعد",
  "You can add your packages once your profile is complete. Click the 'Complete Profile' button to fill in the necessary details and start adding your packages.": "يمكنك إضافة حزمك بمجرد اكتمال ملفك الشخصي. انقر فوق الزر \"إكمال الملف الشخصي\" لملء التفاصيل الضرورية والبدء في إضافة الطرود الخاصة بك.",
  "You can start adding your packages once your profile is approved. We'll notify you as soon as your profile is ready for package submissions. In the meantime, feel free to explore other features!": "يمكنك البدء في إضافة حزمك بمجرد الموافقة على ملفك الشخصي. سنقوم بإعلامك بمجرد أن يصبح ملفك الشخصي جاهزًا لإرسال الحزمة. في غضون ذلك، لا تتردد في استكشاف الميزات الأخرى!",
  "Complete Profile": "الملف الشخصي الكامل",
  "If you make any edits to the details below, this package will be subject to review again. During this review period, this package will not be visible on the customer portal until it is approved again.": "إذا قمت بإجراء أي تعديلات على التفاصيل أدناه، فستخضع هذه الحزمة للمراجعة مرة أخرى. خلال فترة المراجعة هذه، لن تكون هذه الحزمة مرئية على بوابة العميل حتى تتم الموافقة عليها مرة أخرى.",
  "If you make any edits to the details below, this vendor's profile will be subject to review again. During this review period, his/her packages will not be visible on the customer portal until his/her profile is approved.": "إذا قمت بإجراء أي تعديلات على التفاصيل أدناه، فسيخضع الملف الشخصي لهذا البائع للمراجعة مرة أخرى. خلال فترة المراجعة هذه، لن تكون حزمه مرئية على بوابة العميل حتى تتم الموافقة على ملفه الشخصي.",
  "If you make any edits to the details below, your profile will be subject to review again. During this review period, your packages will not be visible on the customer portal until your profile is approved.": "إذا قمت بإجراء أي تعديلات على التفاصيل أدناه، فسيخضع ملفك الشخصي للمراجعة مرة أخرى. خلال فترة المراجعة هذه، لن تكون الطرود الخاصة بك مرئية على بوابة العملاء حتى تتم الموافقة على ملفك الشخصي.",
  "Rejection Reason": "سبب الرفض",
  "Vendor Type": "نوع البائع",
  "Service Description": "وصف الخدمة",
  "Service Description must be at least 1 character": "يجب أن يتكون وصف الخدمة من حرف واحد على الأقل",
  "Service Description must be at most 255 characters": "يجب أن يكون وصف الخدمة 255 حرفًا على الأكثر",
  "Service Description is required": "مطلوب وصف الخدمة",
  "Business Description must be at least 1 character": "يجب أن يتكون وصف العمل من حرف واحد على الأقل",
  "Business Description must be at most 255 characters": "يجب أن يكون وصف العمل 255 حرفًا على الأكثر",
  "Business Description is required": "مطلوب وصف الأعمال",
  "Review Profile": "مراجعة الملف الشخصي",
  "Already Rejected": "تم رفضه بالفعل",
  "Already Approved": "تمت الموافقة عليه بالفعل",
  "Finish": "ينهي",
  "Update & Next": "التحديث والتالي",
  "Business TAN": "الأعمال تان",
  "Reject": "يرفض",
  "Approve": "يعتمد",
  "Disable Edit": "تعطيل التحرير",
  "REVIEW AND RATING": "المراجعة والتقييم",
  "Inquiry Status": "حالة الاستفسار",
  "Booking Status": "حالة الحجز",
  "Date": "تاريخ",
  "Comment": "تعليق",
  "Domain Name": "اسم المجال",
  "Comment added and vendor rejected successfully": "تمت إضافة التعليق وتم رفض البائع بنجاح",
  "Comment added and package rejected successfully": "تمت إضافة التعليق وتم رفض الحزمة بنجاح",
  "The domain name must be at least 1 character": "يجب أن يتكون اسم المجال من حرف واحد على الأقل",
  "The domain name must be at most 100 characters": "يجب أن يكون اسم المجال 100 حرفًا على الأكثر",
  "Only -, _, & characters are allowed and no spaces": "يُسمح فقط بأحرف - و_ و& بدون مسافات",
  "The domain name field is required": "حقل اسم المجال مطلوب",
  "Domain name already exists": "اسم المجال موجود بالفعل",
  "No Images Found": "لم يتم العثور على صور",
  "You can select a maximum of 5 images. Please deselect an image before selecting another if you've reached the limit.": "يمكنك اختيار 5 صور كحد أقصى. يرجى إلغاء تحديد صورة قبل تحديد صورة أخرى إذا وصلت إلى الحد الأقصى.",
  "Choose Any 5 Best Images": "اختر أي 5 أفضل الصور",
  "Makkah Hotel Details": "تفاصيل فندق مكة",
  "Madinah Hotel Details": "تفاصيل فندق المدينة المنورة",
  "Only JPEG, JPG, PNG, and PDF files are supported. Please upload a valid file.": "يتم دعم ملفات JPEG، وJPG، وPNG، وPDF فقط. يرجى تحميل ملف صالح.",
  "Only JPEG, JPG, PNG, and GIF files are supported. Please upload a valid file.": "يتم دعم ملفات JPEG، وJPG، وPNG، وGIF فقط. يرجى تحميل ملف صالح.",
  "Error while downloading file": "حدث خطأ أثناء تنزيل الملف",
  "File downloaded successfully": "تم تنزيل الملف بنجاح",
  "File size exceeds the maximum limit of 2MB.": "يتجاوز حجم الملف الحد الأقصى وهو 2 ميغابايت.",
  "Location Master": "إدارة المواقع",
  "Add Location": "إضافة موقع",
  "Update Location": "تحديث الموقع",
  "City Name": "اسم المدينة",
  "State Name": "اسم الولاية",
  "Country Name": "اسم الدولة",
  "City Image": "صورة المدينة",
  "Select Image": "اختر صورة",
  "Location added successfully": "تم إضافة الموقع بنجاح",
  "Location updated successfully": "تم تحديث الموقع بنجاح",
  "Status updated successfully": "تم تحديث الحالة بنجاح",
  "Failed to update status": "فشل في تحديث الحالة",
  "Search by country or city...": "البحث بالدولة أو المدينة...",
  "No locations found": "لم يتم العثور على مواقع",
  "State Name (Optional)": "اسم الولاية (اختياري)",
  "Default State": "الولاية الافتراضية"
};

export default aeJSON;
